import type { TreeSelectProps } from 'antd'
import { TreeSelect } from 'antd'
import * as styles from './mobile-treeselect.module.scss'

export const MobileTreeSelect = (props: TreeSelectProps) => {
    return (
        <div className={styles.inputCard}>
            <TreeSelect className={styles.mobileTreeSelect} {...props} />
        </div>
    )
}
